import { FieldSet, RecordData } from "airtable"
import ReactMarkdown from "react-markdown"
import tw from "twin.macro"
import { ContentDataProps } from "../../pages/[parent]"
import { StyledBodyText } from "../bodyText"

const Card = (props: RecordData<FieldSet>) => {
  const { body, year } = props.fields

  const bodyText = body ? body.toString() : ""

  return (
    <div>
      <h3 tw="text-2xl">{year && year.toString()}</h3>
      <StyledBodyText>
        <ReactMarkdown>{bodyText}</ReactMarkdown>
      </StyledBodyText>
    </div>
  )
}

const Bibliography = (props: ContentDataProps) => {
  const { contentData } = props

  return (
    <div tw="max-w-screen-desktop-lg desktop-lg:mx-auto px-4 relative">
      <div tw="grid grid-cols-4 desktop:(grid-cols-12) gap-4 desktop:(gap-6)">
        <div tw="col-span-4 tablet-lg:col-span-8">
          <div tw="space-y-6">
            {contentData.map((item: any, i: number) => {
              return <Card {...item} key={i} />
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Bibliography
